
import { FETCH_METHODS, SearchConfig } from "./api.model";
import { OptionsFetchConfig } from "./common.model";
import { AreaDropdown, defaultSearchContainerButtons, MonthDropdown, YearDropdown, FieldNames, DistrictDropdown, RangeDropdown, CertifiableRolesDropdown, NonCertifiableRolesDropdown } from "./form-fields.model";
import { FormFieldConfig, ButtonFieldConfig, DynamicFormArray } from "./form.model";
import { TurnOverReportAreaSearchConfig, SearchKeys } from "./turn-over.model";

export { 
  TurnOverTableSchema as LexusTurnoverDisplayTable, 
  TurnoverProps as LexusTurnoverProps, 
  TurnOverTabIds as LexusTurnoverTabIds, 
  TurnoverReportTabConfig as LexusTurnoverTabConfigIds 
} from "./turn-over.model";

export const LexusTurnOverTableData =[];
export const LexusTurnOverTitle = "Lexus Turnover Dashboard";
export const LexusTurnReportDynamicOptionSchema: OptionsFetchConfig = {
    fields: [
        { name: FieldNames['JobRole'], keyValuePair: { fieldLabel: 'JobRoles', fieldValue: 'JobRoles' } }
    ],
    searchConfig: {
        method: FETCH_METHODS['Get'],
        path: 'jobCodes',
    }
}

export const LexusTurnOverReportAreaSearchConfig:SearchConfig = {
    ...structuredClone(TurnOverReportAreaSearchConfig),
    path:'turnOverReport',
    body:{...TurnOverReportAreaSearchConfig['body']}
}

export const LexusTurnOverReportCertificationSearchConfig:SearchConfig = {
    method: FETCH_METHODS['Post'],
    path:'turnOverReportCertification',
    body:{...TurnOverReportAreaSearchConfig['body']}
}

export const LexusTurnOverReportSearchConfig:Record<string,SearchConfig> = {
    [SearchKeys['Area']]: LexusTurnOverReportAreaSearchConfig,
    [SearchKeys['Certificate']]: LexusTurnOverReportCertificationSearchConfig
}
const FormFieldArray: FormFieldConfig[] = structuredClone([
    {...structuredClone(CertifiableRolesDropdown), isLoading:true, required:true, multiple: false, isDependentOn: null}, 
    { ...structuredClone(NonCertifiableRolesDropdown), isLoading:true, multiple:false }, 
    {...structuredClone(AreaDropdown), multiple:false, showSelect:false, options: [{ fieldLabel: 'National', fieldValue: '' },{ fieldLabel: '31 - WESTERN AREA', fieldValue: '31' }, { fieldLabel: '32 - CENTRAL AREA', fieldValue: '32' }, { fieldLabel: '33 - EASTERN AREA', fieldValue: '33' }, { fieldLabel: '34 - SOUTHERN AREA', fieldValue: '34' }]}, 
    {...DistrictDropdown, disabled: true, isDependentOn:FieldNames['Area'], showSelect:false, options: [{ fieldLabel: 'ALL', fieldValue: '' }, { fieldLabel: '01', fieldValue: '01' }, { fieldLabel: '02', fieldValue: '02' }, { fieldLabel: '03', fieldValue: '03' }, { fieldLabel: '04', fieldValue: '04' }, { fieldLabel: '05', fieldValue: '05' }, { fieldLabel: '06', fieldValue: '06' }]}, 
    {...structuredClone(RangeDropdown), showSelect:false},
    {...structuredClone(MonthDropdown), required:true, showSelect: false}, 
    {...structuredClone(YearDropdown), showSelect:false, options:[{fieldLabel:2019,fieldValue:'2019'},{fieldLabel:2020,fieldValue:'2020'},{fieldLabel:2021,fieldValue:'2021'},{fieldLabel:2022,fieldValue:'2022'},{fieldLabel:2023,fieldValue:'2023'},{fieldLabel:2024,fieldValue:'2024'},{fieldLabel:2025,fieldValue:'2025'},{fieldLabel:2026,fieldValue:'2026'}], required:true}]);

const FormButtonArray: ButtonFieldConfig[] = structuredClone(defaultSearchContainerButtons);
export const LexusTurnOverFilterSchema: DynamicFormArray = {
    FieldsArray: FormFieldArray,
    ButtonsArray: FormButtonArray,
    searchConfig:TurnOverReportAreaSearchConfig
}




